import { render, staticRenderFns } from "./sparePartsWarehousing.vue?vue&type=template&id=a61b0126&scoped=true&"
import script from "./sparePartsWarehousing.vue?vue&type=script&lang=js&"
export * from "./sparePartsWarehousing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61b0126",
  null
  
)

export default component.exports